<template>
  <div
    class="lead-flow-stage-marker ui-stage-marker"
    :class="{
      'lead-flow-stage-marker--first': first, 'ui-stage-marker--first': first,
      'lead-flow-stage-marker--last': last, 'ui-stage-marker--last': last
    }"
    aria-hidden="true"
  >
    <span class="lead-flow-stage-marker__line ui-stage-marker__line"></span>
    <span class="lead-flow-stage-marker__icon ui-stage-marker__icon">
      <img :src="stageIcon" alt="">
    </span>
  </div>
</template>

<script>
const STAGE_ICONS = {
  unassigned: require('@/assets/img/lead-flow/stage-unassigned.svg'),
  make_decision: require('@/assets/img/lead-flow/stage-make-decision.svg'),
  new_leads: require('@/assets/img/lead-flow/stage-new-leads.png'),
  first_contact: require('@/assets/img/lead-flow/stage-first-contact.png'),
  qualification: require('@/assets/img/lead-flow/stage-qualification.png'),
  prepare_offer: require('@/assets/img/lead-flow/stage-prepare-offer.png'),
  sell_offer: require('@/assets/img/lead-flow/stage-sell-offer.png'),
  sell_invoice: require('@/assets/img/lead-flow/stage-sell-invoice.png')
}

export default {
  name: 'LeadFlowStageMarker',
  props: {
    code: {
      type: String,
      required: true
    },
    first: {
      type: Boolean,
      default: false
    },
    last: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    stageIcon() {
      return STAGE_ICONS[this.code] || STAGE_ICONS.qualification
    }
  }
}
</script>
